// Browser-facing ESM facade. Node build tools require publicSite.cjs directly.
import publicSite from './publicSite.cjs';

export const ORIGIN = publicSite.ORIGIN;
export const organization = publicSite.organization;
export const articles = publicSite.articles;
export const aliases = publicSite.aliases;
export const normalizePath = publicSite.normalizePath;
export const getPage = publicSite.getPage;
export const getMetadata = publicSite.getMetadata;
export const publicPaths = publicSite.publicPaths;
